import { useGetCustomer } from "@/api/customer/customer.ts"
import { authSession } from "@/authentication/authenticationService"
import { MyAccountRoute } from "@/constants/routes/myAccount.ts"
import { computed, watch } from "vue"
import { useRouter } from "vue-router"

export function useGetAccountId() {
  const { isAuthenticated } = authSession
  const router = useRouter()

  const customer = useGetCustomer({
    query: {
      enabled: isAuthenticated,
    },
  })

  watch(
    () => customer.error.value,
    (error) => {
      if (!error || customer.data.value) return

      if (import.meta.env.DEV) {
        console.warn(
          `Skipping redirect to account load error page in dev mode.\n` +
            `Would redirect to: ${MyAccountRoute.accountLoadError}`,
        )
        return
      }

      router.push(MyAccountRoute.accountLoadError)
    },
    { immediate: true },
  )

  const accountId = computed(() => {
    return customer.data?.value?.accountIDLastVisited ?? 0
  })

  return {
    accountId,
    ...customer,
  }
}
